import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  Grid,
  Card,
  Menu,
  MenuItem,
  CircularProgress,
  IconButton,
  Switch,
} from "@mui/material";
import {
  getDatabase,
  ref,
  onValue,
  set,
  get,
  update,
  child,
  onChildAdded,
  onChildChanged,
  remove,
  onChildRemoved,
} from "firebase/database";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { ToastContainer, toast } from "react-toastify";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TokenDialogBox from "../../DialogBox/tokenData";
import EmptyData from "../../components/EmptyData";
import { useSelector } from "react-redux";
import ButtonContainer from "Utils/approvedRejectDeleteButton.";

const AdminAccess = () => {
  const getUserState = useSelector((state) => state?.data?.getUserState);
  const [allData, setAllData] = useState([]);
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);

  const navigate = useNavigate();

  const getData = () => {
    const getAdminInfo = JSON.parse(localStorage.getItem("user"));
    const getAdminState = getAdminInfo?.state;
    const useradmin = getAdminInfo?.superAdmin;
    setCheckSuperAdmin(useradmin);
    setAdminState(getAdminState);
    const db = getDatabase();
    const dbRef = ref(db, "adminLogin");
    console.log(dbRef);

    get(dbRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = Object.values(snapshot.val());
          console.log("data", Object.values(data));

          let filteredData;

          if (useradmin) {
            if ((useradmin && getUserState === "") || (useradmin && getUserState === "All State")) {
              filteredData = data;
            } else {
              filteredData = data.filter((item) => item.state === getUserState);
            }
          } else {
            filteredData = data.filter((item) => item.state === getAdminState);
          }
          setAllData(filteredData);
        } else {
          setAllData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setAllData([]);
      });
  };

  const handleApproveReject = (user, action) => {
    const db = getDatabase();
    const userRef = ref(db, `adminLogin/${user?.userKey}`);
    console.log("userRef", userRef);

    let adminAccessValue = false;
    if (action === "approved") {
      adminAccessValue = "Approved";
    } else if (action === "rejected") {
      adminAccessValue = "Rejected";
    }

    update(userRef, {
      adminAccess: adminAccessValue,
      applicationReviewed: true,
    })
      .then(() => {
        toast.success("Admin Access Permission Successfully Done!");
        getData();
      })
      .catch((error) => {
        console.error(`Error updating admin access: ${error}`);
      });
  };

  const handleDelete = (user) => {
    const db = getDatabase();
    const dbRef = ref(db, `adminLogin/${user?.userKey}`);

    remove(dbRef)
      .then(() => {
        toast.success("Admin Access User Delete Successfully Done!");
        getData();
      })
      .catch((error) => {
        console.error("Error deleting admin:", error);
      });
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
    }
    getData();
  }, [getUserState]);
  return (
    <DashboardLayout>
      <MDBox pt={12} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  textAlign: "center",
                }}
              >
                <ToastContainer />
                <MDTypography
                  variant="h6"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                  }}
                >
                  {checkSuperAdmin
                    ? getUserState === ""
                      ? "ALL STATE "
                      : `${getUserState?.toUpperCase()} STATE `
                    : `${adminState?.toUpperCase()} STATE `}
                  ADMIN ACCESS DASHBOARD
                </MDTypography>
              </MDBox>

              {allData.length > 0 ? (
                <MDBox>
                  <TableContainer component={Paper}>
                    <Table aria-label="user table">
                      <TableBody>
                        <TableRow>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                          >
                            SR
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                          >
                            Name
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Email
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Phone
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            State
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Application Reviewed
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Admin Access
                          </TableCell>

                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableBody>
                      {allData
                        .filter((notification) => notification?.superAdmin !== true)
                        .map((notification, index) => {
                          let rowColor = "";
                          if (notification?.adminAccess === "Approved") {
                            rowColor = "lightgreen";
                          } else if (notification?.adminAccess === "Pending") {
                            rowColor = "lightyellow";
                          } else if (notification?.adminAccess === "Rejected") {
                            rowColor = "lightcoral";
                          }

                          return (
                            <TableRow
                              key={index}
                              sx={{ height: "auto", backgroundColor: rowColor }}
                            >
                              <TableCell align="center" sx={{ padding: "6px" }}>
                                {index + 1}
                              </TableCell>
                              <TableCell
                                sx={{ padding: "6px", fontSize: "14px" }}
                                component="th"
                                scope="row"
                              >
                                <Avatar
                                  src={notification?.imageUrl}
                                  alt={notification?.firstName}
                                />
                                {notification?.firstName} {notification?.lastName}
                              </TableCell>
                              <TableCell align="center" sx={{ padding: "6px", fontSize: "14px" }}>
                                {notification?.email}
                              </TableCell>
                              <TableCell align="center" sx={{ padding: "6px", fontSize: "14px" }}>
                                {notification?.phoneNumber}
                              </TableCell>
                              <TableCell align="center" sx={{ padding: "6px", fontSize: "14px" }}>
                                {notification?.state}
                              </TableCell>
                              <TableCell align="center" sx={{ padding: "6px", fontSize: "14px" }}>
                                {notification?.applicationReviewed ? (
                                  <p>Reviewed</p>
                                ) : (
                                  <p>Pending</p>
                                )}
                              </TableCell>
                              <TableCell align="center" sx={{ padding: "6px", fontSize: "14px" }}>
                                {notification?.adminAccess}
                              </TableCell>
                              <TableCell align="center" sx={{ padding: "6px", fontSize: "14px" }}>
                                <ButtonContainer
                                  notification={notification}
                                  handleApproveReject={handleApproveReject}
                                  handleDelete={handleDelete}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </Table>
                  </TableContainer>
                </MDBox>
              ) : (
                <EmptyData />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default AdminAccess;
